export const CRUISE_FLOW_HISTORY_KEY = 'shipplayCruiseFlow';

export const makeLandingState = (baseState = {}) => ({
  ...baseState,
  flowKey: CRUISE_FLOW_HISTORY_KEY,
  stage: 'landing'
});

export const makeStep1State = () => ({
  flowKey: CRUISE_FLOW_HISTORY_KEY,
  stage: 'step1'
});

export const makeInFlowState = (pageIndex) => ({
  flowKey: CRUISE_FLOW_HISTORY_KEY,
  stage: 'inFlow',
  pageIndex
});

export const pageIndexFromPopState = (state) => {
  if (state?.flowKey !== CRUISE_FLOW_HISTORY_KEY) return null;

  if (state.stage === 'landing') return -1;
  if (state.stage === 'step1') return 0;

  if (state.stage === 'inFlow') {
    const pageIndex = Number.isFinite(state.pageIndex) ? state.pageIndex : 1;
    return Math.max(1, pageIndex);
  }

  return null;
};

export const historyOpForNext = (currentPage) => {
  if (currentPage === 0) {
    return { op: 'push', nextPage: 1, state: makeInFlowState(1) };
  }

  if (currentPage >= 1 && currentPage < 2) {
    const nextPage = currentPage + 1;
    return { op: 'replace', nextPage, state: makeInFlowState(nextPage) };
  }

  return null;
};

export const historyOpForPrev = (currentPage) => {
  if (currentPage === 1) {
    return { op: 'back', nextPage: 0, state: null };
  }

  if (currentPage > 1) {
    const nextPage = currentPage - 1;
    return { op: 'replace', nextPage, state: makeInFlowState(nextPage) };
  }

  return null;
};

export const historyOpForSelect = ({ currentPage, targetPage }) => {
  if (targetPage === currentPage) return null;

  if (targetPage === 0 && currentPage > 0) {
    return { op: 'back', nextPage: 0, state: null };
  }

  if (targetPage > 0 && currentPage === 0) {
    return { op: 'push', nextPage: targetPage, state: makeInFlowState(targetPage) };
  }

  if (targetPage > 0 && currentPage > 0) {
    return { op: 'replace', nextPage: targetPage, state: makeInFlowState(targetPage) };
  }

  return { op: 'none', nextPage: targetPage, state: null };
};

